import React from "react";

/**
 * One row in a post list — used by the pending, refresh and published sections
 * of the review screen so the three stay visually consistent.
 *
 * `meta` and `actions` are slots rather than fixed props: each section shows
 * different sub-text (refresh signals vs. read time) and different controls
 * (delete on published, none on pending), while the layout stays shared.
 */
const BlogPostRow = ({ post, onClick, title, badge, meta, actions, titleClassName = "" }) => (
  <div
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick?.(); }
    }}
    className="w-full text-left px-5 py-4 hover:bg-gray-50 transition-colors flex items-center gap-3 group cursor-pointer"
  >
    <span className="text-2xl shrink-0">{post.emoji || "📝"}</span>

    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2 flex-wrap">
        {badge}
        <p className={`font-medium text-gray-900 truncate group-hover:text-blue-600 transition-colors ${titleClassName}`}>
          {title ?? post.title}
        </p>
      </div>
      {meta}
    </div>

    {post.image && (
      <img
        src={post.image}
        alt=""
        className="w-16 h-10 object-cover rounded shrink-0 opacity-80"
      />
    )}

    {actions}

    <span className="text-gray-300 group-hover:text-gray-500 shrink-0">›</span>
  </div>
);

export default BlogPostRow;
